"use client"
import { ReactNode } from 'react';
import { Empty as AntdEmpty} from 'antd';

export function Empty({ children, className }: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={`w-full bg-background-card rounded-lg p-8 text-center mx-auto ${className}`}>
      <div className="w-32 h-24 mt-4 rounded-full flex items-center justify-center mx-auto mb-4 relative">
        <AntdEmpty image={AntdEmpty.PRESENTED_IMAGE_SIMPLE} description="" style={{
          transform: 'scale(1.8)'
        }}/>
      </div>
      <p className="text-sm text-font-primary/50 text-center m-auto mb-4 w-[350px] max-w-full max-w-full">
        {children}
      </p>
    </div>
  )
}